export const nl = {
  title: 'Tropische boombedekking',
  subtitle: '2020, 10 m/0.5 ha, tropical, WRI',
  download_data: 'https://data.globalforestwatch.org/datasets/tropical-tree-cover/explore',
  learn_more: '',
  content: [
    {
      label: 'Functie',
      value:
        'Geeft de omvang van bomen weer op een schaal van tien meter en de boombedekking op een schaal van een halve hectare om nauwkeurige monitoring van bomen in stedelijke gebieden, landbouwgronden en in ecosystemen met open bladerdak en droge bossen mogelijk te maken',
    },
    {
      label: 'Resolutie',
      value: '10 x 10 meter, halve hectare',
    },
    {
      label: 'Geografische dekking',
      value: '4,3 miljard hectare van de tropen (-23,44 tot 23,44 breedtegraad)',
    },
    {
      label: 'Bron',
      value: 'World Resources Institute',
    },
    {
      label: 'Frequentie',
      value: 'Jaarlijkse wijzigingsdetectiekaarten die in 2017 beginnen, zijn gepland voor de release van 2024.',
    },
    {
      label: 'Datum van inhoud',
      value: '2020',
    },
    {
      label: 'Waarschuwingen',
      value:
        'Deze dataset gebruikt een andere definitie van een boom en een andere definitie van boombedekking dan Hansen et al. (2013). Deze dataset definieert een boom op basis van zowel de hoogte als de kroondiameter. Houtachtige vegetatie hoger dan 5 meter, ongeacht de kroondiameter, of tussen 3 en 5 meter met een minimale kroondiameter van 5 meter wordt als een boom beschouwd. Deze definitie verschilt van Hansen et al. (2013) die een boom definieert als elke vegetatie van ten minste 5 meter hoog. De dataset voor tropische boombedekking maakt geen onderscheid tussen plantagebomen en niet-plantagebomen.\n\nAnalyses of statistieken die zijn afgeleid voor shapefiles kleiner dan 0,5 ha zijn mogelijk niet nauwkeurig.',
    },
    {
      label: 'Licentie',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'De gegevens over de tropische boombedekking brengen de omvang van de bomen op een schaal van tien meter en de boombedekking op de schaal van een halve hectare in kaart om nauwkeurige monitoring van bomen in stedelijke gebieden, landbouwgronden en in open bladerdak en droge bosecosystemen mogelijk te maken. De gegevens strekken zich uit over 4,3 miljard hectare van de wereldwijde tropen.\n\nDe gegevens zijn afgeleid van multitemporele convolutionele neurale netwerkmodellen die zijn toegepast op optische en radarbeelden van Sentinel. De dataset van 10 meter is een binaire boomomvangslaag die vergelijkbaar is met een landbedekkingskaart, terwijl de gegevens over de boombedekking een fractionele bedekking op een schaal van een halve hectare vertegenwoordigen. Meer details over de methodologie en analyses zijn te vinden op de GitHub-pagina.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'Use the following credit when this data is displayed: Source: 14/02/2025, accessed through Global Forest Watch on 14/02/2025\n\nUse the following credit when this data is cited: Brandt,\nBrandt, J., Ertel, J., Spore, J., & Stolle, F. (2023). WALL-to-wall\nmapping of tree extent in the tropics with sentinel-1 and sentinel-2. Remote Sensing of Environment, 292, 113574. https://doi.org/10.1016/j.rse.2023.11357',
  },
};
